
import Responder from './../zviz3/responder';
import SimpleEvent from './../zviz3/event';
import state from './../zviz3/state';


class SizeWatcher extends Responder{

    static instance = null;

    static getInstance(container){
        if(! SizeWatcher.instance){
            SizeWatcher.instance = new SizeWatcher(container);
        }
        return SizeWatcher.instance;
    }

    constructor(container){      
        super();
        this.timerId = null;
        this.container = container;
        this.event = new SimpleEvent(window, 'resize', [this, this.onResize]);
        this.curSize = [0, 0];
        this.setSize = this.setSize.bind(this);
        this.setSize();
    }

    onResize(event){
        clearTimeout(this.timerId);
        this.timerId = setTimeout(this.setSize, 500);
    }

    setSize(){ 
        // note: this includes padding, that we do not want. However in normal situations
        // passing will be 0. If not, use getComputedStyle to substract padding.
        const w = this.container.clientWidth || (this.container.offsetWidth || 1200);
        const h = this.container.clientHeight || (this.container.offsetHeight || 800);

        this.curSize = [w, h];
        
        let size = 'large';
        if(w < 600){
            size = 'small';
        }else if(w < 1000){
            size = 'medium';
        }
        state.set('renderSize', size);
        
        this.trigger();
    }

    getData(){
        return this.curSize.slice(0);
    }

    remove(){
        clearTimeout(this.timerId);
        this.event.remove();
    }
}

export default SizeWatcher;


// WEBPACK FOOTER //
// ./src/helpers/size.js